/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
type ReplacementOption = "replace-element" | "replace-attribute-only";
type AttributeValue = {
  readonly [Key: string]: string;
};

export function replaceHtmlElementById(
  elementId: string,
  replaceElement?: string | AttributeValue,
  replacementOption?: ReplacementOption
) {
  const isReplaceElement =
    replacementOption === "replace-element" &&
    typeof replaceElement === "string";
  const element = document.getElementById(elementId);
  if (element?.outerHTML && replaceElement) {
    if (isReplaceElement) {
      element.outerHTML = replaceElement;
    } else if (typeof replaceElement === "object") {
      Object.keys(replaceElement).forEach((key) => {
        const attribute = key;
        const value = replaceElement[key];
        element.setAttribute(attribute, value);
      });
    }
  }
}
